import _ from 'lodash';

export const parseFooterText = (
  text: string,
  variables: { [key: string]: string | boolean }
): string => {
  let newText = text;

  /*
   * Find substring based on if-start (#if) and if-end (/if) pattern.
   * E.g. "<div><span>Main text<span/>{{#if showSubText}}<span>Secondary text<span/>{{/if}}<div/>"
   *    -> "{{#if showSubText}}<span>Secondary text<span/>{{/if}}"
   */
  const ifPattern = /\{{\s*#if.*?}}(.*?)\{{\s*\/if\s*}}/gm;

  /*
   * Find substring with 'if' condition value
   * E.g. "{{#if showSubText}}<span>Secondary text<span/>{{/if}}"
   *    -> " showSubText"
   */
  const varPattern = /\{{\s*#if(.*?)}}/gm;

  /*
   * Continue until if-statements are being found
   */
  while (newText.match(ifPattern)) {
    /*
     * Substring if-statement part (e.g. "{{#if showSubText}}<span>Secondary text<span/>{{/if}}")
     */
    const ifSubstring = _.head(newText.match(ifPattern)) || '';

    /*
     * Substring if-statement condition variable (e.g. match[1] === "showSubText")
     */
    const matchCondition = ifSubstring && varPattern.exec(ifSubstring);

    /*
     * Substring if-statement content (e.g. "<span>Secondary text<span/>")
     */
    const matchBody = ifSubstring && ifPattern.exec(ifSubstring);

    /*
     * Break down main text into "before if" amd "after if" strings
     */
    const middleStrPos = newText.indexOf(ifSubstring);
    const beforeStr = newText.substring(0, middleStrPos);
    const afterStr = newText.substring(middleStrPos + ifSubstring.length);

    /*
     * By default if-body is removed
     */
    newText = beforeStr + afterStr;

    if (
      variables &&
      matchCondition &&
      matchCondition[1] &&
      matchBody &&
      matchBody[1]
    ) {
      const foundVar = _.trim(matchCondition[1]);

      if (_.isBoolean(variables[foundVar]) && variables[foundVar] === true) {
        /*
         * Add if-body when condition is met
         */
        newText = beforeStr + matchBody[1] + afterStr;
      }
    }
  }

  /*
   * Find all variables which are defined and replace their values in string
   */
  _.chain(variables)
    .keys()
    .forEach((variable: string) => {
      const regExp = new RegExp(`{{\\s*${variable}\\s*}}`, 'g');
      if (variables && variables[variable]) {
        newText = newText.replace(regExp, variables[variable].toString());
      }
    })
    .value();

  /*
   * Find all variables which are NOT found and remove
   */
  newText = newText.replace(/\{{.*?}}/gm, '');

  return newText;
};
